import CookieConsent from 'react-cookie-consent';
import { Platform } from 'react-native';
import { Trans } from '@lingui/react/macro';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react';

export default function CookieConsentBanner() {
    const { i18n } = useLingui();
    // Only render on web
    if (Platform.OS !== 'web') {
        return null;
    }

    return (
        <CookieConsent
            location="bottom"
            buttonText={i18n._(msg({ id: 'cookie.action.accept', message: 'Accept' }))}
            declineButtonText={i18n._(msg({ id: 'cookie.action.decline', message: 'Decline' }))}
            ariaAcceptLabel={i18n._(msg({ id: 'cookie.action.accept', message: 'Accept' }))}
            ariaDeclineLabel={i18n._(msg({ id: 'cookie.action.decline', message: 'Decline' }))}
            cookieName="paperzilla-cookie-consent"
            enableDeclineButton
            style={{
                backgroundColor: "#2B373B",
                fontSize: "12px",
                // Reserve the launcher's corner so neither consent action is obscured.
                padding: "6px 90px 6px 20px",
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
                minWidth: "unset",
                width: "100%",
                boxSizing: "border-box",
                height: "auto",
                minHeight: "unset",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
            }}
            buttonStyle={{
                backgroundColor: "#4CAF50",
                color: "white",
                fontSize: "12px",
                borderRadius: "4px",
                padding: "4px 12px",
                margin: "0 4px",
                fontFamily: "inherit",
                fontWeight: "500",
            }}
            declineButtonStyle={{
                backgroundColor: "transparent",
                color: "white",
                fontSize: "12px",
                borderRadius: "4px",
                padding: "4px 12px",
                border: "1px solid white",
                margin: "0 4px",
                fontFamily: "inherit",
                fontWeight: "500",
            }}
            disableStyles={false}
            buttonWrapperClasses=""
            contentStyle={{
                margin: "0",
                maxWidth: "600px",
                minWidth: "unset",
                lineHeight: "1.3",
                flex: "1",
            }}
            expires={365}
        ><Trans id="cookieconsentbanner.weUseCookiesToEnhanceYourExperienceAndAnalyzeSite" comment="UI copy in components/CookieConsentBanner.tsx">
            We use cookies to enhance your experience and analyze site usage.
        </Trans></CookieConsent>
    );
}
